import type { ReactNode } from 'react';

interface LinhaConfigProps {
  titulo: ReactNode;
  descricao?: ReactNode;
  /** Controle alinhado à direita (toggle, input, select, botão). */
  children?: ReactNode;
  /** Última linha do painel não leva divisória. */
  ultima?: boolean;
}

/** Linha de configuração Íris: título+descrição à esquerda, controle à direita. */
export default function LinhaConfig({ titulo, descricao, children, ultima = false }: LinhaConfigProps) {
  return (
    <div className={`flex flex-col gap-2 py-3.5 sm:flex-row sm:items-center sm:gap-4 ${ultima ? '' : 'border-b border-line'}`}>
      <div className="min-w-0 sm:flex-1">
        <div className="text-sm font-medium text-tx">{titulo}</div>
        {descricao && <div className="text-[13px] text-tx-3 mt-0.5">{descricao}</div>}
      </div>
      {children && <div className="flex shrink-0 flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}
